import { createTheme } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import Customertable from '../../components/ManageCustomer/Customertable';
const defaultTheme = createTheme();
const ManageCustomer = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <Customertable />
    </ThemeProvider>
  )
}

export default ManageCustomer